import { AppBar } from '@mui/material';

export const TabsBar = ({ children }) => {
  return (
    <AppBar
      position="static"
      color="default"
      component="div"
      sx={{
        backgroundColor: '#fff',
        boxShadow: 'none',
        borderBottom: theme => `1px solid ${theme.palette.grey[400]}`
      }}
    >
      {children}
    </AppBar>
  );
};
